// extracted by mini-css-extract-plugin
export var growableInput = "_44-0";
export var tagContainer = "_44-2";
export var textInput = "_44-1";